import { configureStore } from '@reduxjs/toolkit';

import appReducer from './ducks/app';
import formularioReducer from './ducks/formulario';
import sefazReducer from './ducks/sefaz';
import atendenteReducer from './ducks/atendente';
import servicoReducer from './ducks/servico';
import setorReducer from './ducks/setor';
import statusReducer from './ducks/status';
import dadosCadastraisReducer from './ducks/dadosCadastrais';
import inputsReducer from './ducks/inputs';
import relatoriosReducer from './ducks/relatorios';
import postosAtendimentoReducer from './ducks/postosAtendimento';

export default configureStore({
  reducer: {
    app: appReducer,
    formulario: formularioReducer,
    sefaz: sefazReducer,
    atendente: atendenteReducer,
    servico: servicoReducer,
    setor: setorReducer,
    status: statusReducer,
    dadosCadastrais: dadosCadastraisReducer,
    inputs: inputsReducer,
    relatorios: relatoriosReducer,
    postosAtendimento: postosAtendimentoReducer,
  },
});
